export const SHOPIFY_STORE_DOMAIN = process.env.REACT_APP_SHOPIFY_STORE_DOMAIN ?? '';
export const SHOPIFY_STORE_ACCESS_TOKEN = process.env.REACT_APP_SHOPIFY_STORE_ACCESS_TOKEN ?? '';
export const SHOPIFY_STORE_API_KEY = process.env.REACT_APP_SHOPIFY_STORE_API_KEY ?? '';
export const SHOPIFY_STORE_API_SECRET_KEY =
  process.env.REACT_APP_SHOPIFY_STORE_API_SECRET_KEY ?? '';
